export default "__VITE_ASSET__Dfp_n8Ih__"